import React from "react";

/**
 * Reusable summary card with label on the left and value on the right.
 *
 * @param {{ label: string, value: string|number, className?: string }} props
 *
 * @example
 * <SummaryCard label="Total opportunity" value={456} />
 */
const SummaryCard = ({ label, value, className = "" }) => {
  return (
    <div
      className={`flex items-center justify-between p-4 border border-solid border-[#91CAFF] bg-[#E6F4FF] rounded-xl ${className}`}
    >
      <span className="text-base font-normal text-black-88">{label}</span>
      <span className="text-xl font-semibold text-twLinkColor">{value}</span>
    </div>
  );
};

export default SummaryCard;
